import React from 'react'

const SubTabView = ({ Tabs, activeTab, setActiveTab }) => {
  const ActiveContent = Tabs?.[activeTab]?.Content

  return (
    <div className='w-full'>
      <div className='flex items-center gap-2.5 py-1.5'>
        {Tabs.map((tab, index) => (
          <div className='flex flex-col items-center gap-2'>
            <button
              key={index}
              onClick={() => setActiveTab(index)}
              className={`font-bold text-sm rounded-md px-2.5 text-[#000005] ${
                activeTab === index
                  ? 'font-medium'
                  : 'font-normal'
              }`}
            >
              {tab.title}
            </button>
            {activeTab === index && <div className='w-full h-[2px] bg-black' />}
          </div>
        ))}
      </div>

      <div className='mt-4'>{ActiveContent ? <ActiveContent /> : null}</div>
    </div>
  )
}

export default SubTabView
